import { SingleSelectProps } from '@medly-components/core';
import { useRef, useEffect, useState } from 'react';
import { MedlySingleSelect, SelectWrapper } from './SingleSelect.styled';

export const calculateOptionsHeight = (optionsCount: number) => {
    return optionsCount * optionHeight + paddingY;
};

const optionHeight = 40; // in pixels
const paddingY = 16; // in pixels
const minimumOptionsToDisplay = 3;
const maximumOptionsToDisplay = 5;
const minReqSpaceToShowOptions = calculateOptionsHeight(minimumOptionsToDisplay);

export const SingleSelect = (selectProps: SingleSelectProps) => {
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [displayTop, dropdownHeight] = useDropdownBehaviour(dropdownRef);

    return (
        <SelectWrapper maxHeight={dropdownHeight} className={`${displayTop ? 'top' : ''}`} ref={dropdownRef}>
            <MedlySingleSelect
                fullWidth
                includesNestedOptions
                showDecorators
                isSearchable={false}
                size="M"
                required={false}
                variant="outlined"
                placeholder=""
                {...selectProps}
            />
        </SelectWrapper>
    );
};

SingleSelect.displayName = 'SingleSelect';

const useDropdownBehaviour = (dropDownRef: React.RefObject<HTMLDivElement>): [boolean, number] => {
    const maxReqSpaceToShowOptions = calculateOptionsHeight(maximumOptionsToDisplay);
    const [displayTop, setDisplayTop] = useState<boolean>(false);
    const [dropdownHeight, setDropdownHeight] = useState<number>(maxReqSpaceToShowOptions);

    useEffect(() => {
        const bodyHeight = document.body.scrollHeight;
        const dropdownRect = dropDownRef.current?.getBoundingClientRect();
        const availableSpaceAtBottom = dropdownRect ? bodyHeight - dropdownRect.bottom : 0;

        if (availableSpaceAtBottom < minReqSpaceToShowOptions) {
            setDisplayTop(true);
            return;
        }

        const optionsDisplayCount = getOptionsCountToFit(availableSpaceAtBottom);
        const requiredHeight = calculateOptionsHeight(optionsDisplayCount);
        setDropdownHeight(requiredHeight);
    }, [setDisplayTop, setDropdownHeight]);

    return [displayTop, dropdownHeight];
};

export const getOptionsCountToFit = (availableSpaceAtBottom: number) => {
    let optionsCount = minimumOptionsToDisplay;
    let nextDisplayCount = optionsCount + 1;
    while (nextDisplayCount <= maximumOptionsToDisplay && calculateOptionsHeight(nextDisplayCount) < availableSpaceAtBottom) {
        optionsCount = nextDisplayCount;
        nextDisplayCount++;
    }
    return optionsCount;
};
